import { KioskConnectivityStatusUpdate } from '@groundfloor-platform/types-event-grid-events';
import { SignalREventCentre } from '../signalR.eventCentre';
import { ISignalRService } from '../signalR.types';
import { KioskConnectivitySignalRAttributeName, KioskConnectivitySubscriptionStream } from './kioskConnectivity.types';

export class KioskConnectivityEventCentre extends SignalREventCentre<
  KioskConnectivityStatusUpdate,
  KioskConnectivitySubscriptionStream
> {
  private static instance: KioskConnectivityEventCentre;

  private constructor(signalR: ISignalRService) {
    super(signalR, KioskConnectivitySignalRAttributeName, ['iotHubIDs']);
  }

  public static getInstance(signalR: ISignalRService) {
    if (!this.instance) {
      this.instance = new KioskConnectivityEventCentre(signalR);
    }
    return this.instance;
  }
}
